import { ofType } from "redux-observable";
import { combineChecks } from "../../guards/combineChecks";
import { guard } from "../../guards/guard";
import { pathEmpty } from "../../guards/pathEmpty";
import { TypeActionProductionInfo } from "../../info/production/actionProductionInfo";
import { checkTutorialNextStepConfigExists } from "../checks/checkTutorialNextStepConfigExists";
import { checkTutorialQuestClickQuestMenu } from "../checks/checkTutorialQuestClickQuestMenu";
import { pathTutorialUpdate } from "../path/pathTutorialUpdate";
export var epicTutorialQuestClickQuestMenu = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionProductionInfo.Collect), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialQuestClickQuestMenu])(pathTutorialUpdate),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialQuestClickQuestMenu.ts
// module id = 2493
// module chunks = 3